import { Descriptions, Tabs } from "antd";
import { Link, useRouteLoaderData, useSearchParams } from "react-router";
import BackTitle from "../../common/BackTitle";
import Inspections from "../../inspection/Inspections";
import DpiAssignmentHistory from "./DpiAssignmentHistory";

export default function DpiInventoryUnit() {
  const data = useRouteLoaderData("dpiInventoryUnit");
  const [, setSearchParams] = useSearchParams();

  return (
    <div style={{ width: "100%" }}>
      <BackTitle title="Dettagli unità DPI" secondary={`ID: ${data.id}`} />
      <Descriptions
        title="Informazioni generali"
        colon={false}
        column={2}
        items={[
          { key: "serialNumber", label: "Numero seriale", children: data.serialNumber ?? "-" },
          {
            key: "product",
            label: "Prodotto",
            children: data.product && (
              <Link to={`/dpiProducts/${data.product.id}`}>
                {data.product.description || data.product.sku || data.product.id}
              </Link>
            ),
          },
          { key: "sku", label: "SKU prodotto", children: data.product?.sku ?? "-" },
          {
            key: "dpi",
            label: "Categoria DPI",
            children: data.product?.dpi && (
              <Link to={`/dpis/${data.product.dpi.id}`}>{data.product.dpi.name}</Link>
            ),
          },
          {
            key: "status",
            label: "Stato",
            children:
              { AVAILABLE: "Disponibile", NOT_AVAILABLE: "Non disponibile" }[data.status] ??
              data.status,
          },
        ]}
      />
      <Tabs
        style={{ marginTop: 48 }}
        destroyOnHidden
        onChange={() => setSearchParams({}, { replace: true })}
        items={[
          !!data.product?.dpi?.inspectionMonths && {
            key: "inspections",
            label: "Verifiche Periodiche",
            children: <Inspections key={data.id} showTitle={false} type="DPI" id={data.id} />,
          },
          {
            key: "assignments",
            label: "Storico assegnazioni",
            children: <DpiAssignmentHistory id={data.id} />,
          },
        ].filter(Boolean)}
      />
    </div>
  );
}
